import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { calculateDurationFromStartToNow } from '../../utils/duration-date';

@Component({
    selector: 'app-duration',
    templateUrl: 'duration.component.html',
    styleUrls: ['./duration.component.scss'],
})
export class DurationComponent {
    @Input() date: any;
    timeInterVal: any;
    interval: any;
    constructor(private cdr: ChangeDetectorRef) {}

    ngOnChanges(): void {
        if (this.date) {
            this.interval = setInterval(() => {
                this.timeInterVal = calculateDurationFromStartToNow(this.date);
                this.cdr.detectChanges();
            }, 1000);
        }
    }

    ngOnDestroy(): void {
        clearInterval(this.interval);
    }
}
